var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { LocalStorageService } from '@/domains/local-storage/types/local-storage-service.interface';
import { RouterService } from '@cores/services/vue-router-service';
import _ from 'lodash';
import { SUPPORTED_DATA_TYPES } from '../../space/constants';
import { DataType } from '@/domains/base/enums/data-type';
let FolderSortRepositoryImpl = class FolderSortRepositoryImpl {
    constructor(_localStorageService, _routerService) {
        this._localStorageService = _localStorageService;
        this._routerService = _routerService;
    }
    get routerSort() {
        return this._routerService.currentRoute.query.sort;
    }
    getFolderSort(sortQuery) {
        if (this.routerSort) {
            return this.routerSort;
        }
        else {
            const sortLocalKey = this._getFolderSortKey(sortQuery.spaceId, sortQuery.dataType);
            const localSortData = this._getFolderSortData(sortLocalKey);
            const localSort = _.get(localSortData, sortQuery.folderId);
            return localSort;
        }
    }
    setFolderSort(sortData) {
        if (sortData.sort) {
            const sort = this._prepareSortString(sortData.sort);
            const sortLocalKey = this._getFolderSortKey(sortData.spaceId, sortData.dataType);
            const sortLocalData = this._getFolderSortData(sortLocalKey) || {};
            _.set(sortLocalData, sortData.folderId, sort);
            this._localStorageService.setItem(sortLocalKey, sortLocalData);
        }
    }
    clearFolderSort(spaceId) {
        _.forEach(SUPPORTED_DATA_TYPES, (dataType) => {
            const sortLocalKey = this._getFolderSortKey(spaceId, dataType);
            this._localStorageService.removeItem(sortLocalKey);
        });
    }
    _getFolderSortData(key) {
        return this._localStorageService.getItem(key);
    }
    _getFolderSortKey(spaceId, dataType) {
        if (dataType === DataType.PATENT) {
            return `folder-sort-${spaceId}`;
        }
        return `folder-sort-${spaceId}-${dataType}`;
    }
    _prepareSortString(sort) {
        if (!sort)
            return '';
        // 如果是多值排序，直接返回
        const sorts = sort.split(',');
        if (sorts && sorts.length > 1)
            return sort;
        // 如果是自定义字段排序， 补充默认排序
        if (sort.length > 30 && sort.indexOf(':') === -1) {
            return `${sort}:asc`;
        }
        return sort;
    }
};
FolderSortRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(LocalStorageService)),
    __param(1, inject(RouterService)),
    __metadata("design:paramtypes", [typeof (_a = typeof LocalStorageService !== "undefined" && LocalStorageService) === "function" ? _a : Object, typeof (_b = typeof RouterService !== "undefined" && RouterService) === "function" ? _b : Object])
], FolderSortRepositoryImpl);
export { FolderSortRepositoryImpl };
